const reasons = [
  {
    num: "01",
    icon: "ri-flashlight-line",
    title: "最短即日対応",
    text: "京都府内なら、お電話・LINEからのご相談で最短当日中に駆けつけます。急な引越しや退去立会いにも柔軟に対応可能です。",
    alt: "京都の住宅街で軽トラックに不用品を積み込み、最短即日対応を行う様子",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20white%20compact%20kei%20truck%20parked%20in%20front%20of%20traditional%20Japanese%20house%20in%20Kyoto%20residential%20neighborhood%2C%20staff%20loading%20cardboard%20boxes%20and%20furniture%20items%20into%20truck%20bed%20with%20efficient%20speed%2C%20bright%20daytime%20scene%20with%20soft%20natural%20sunlight%2C%20warm%20neutral%20tones%2C%20professional%20waste%20removal%20service%20atmosphere%2C%20editorial%20documentary%20photography%20style%2C%20slightly%20desaturated%20soft%20colors%2C%20Japanese%20corporate%20service%20quality%20aesthetic&width=800&height=600&seq=reason-01-v3&orientation=squarish",
  },
  {
    num: "02",
    icon: "ri-hand-heart-line",
    title: "丁寧な作業",
    text: "京都 遺品整理では、ご遺族のお気持ちに寄り添い、一点一点丁寧に仕分け。近隣への配慮を欠かさず、養生・分別も徹底します。",
    alt: "手袋を着けて思い出の品を丁寧に仕分けする遺品整理の作業風景",
    image:
      "https://readdy.ai/api/search-image?query=Closeup%20of%20gloved%20hands%20carefully%20sorting%20and%20organizing%20personal%20belongings%20into%20neatly%20arranged%20cardboard%20boxes%20and%20clear%20storage%20containers%2C%20clean%20wooden%20floor%20interior%20room%2C%20labels%20visible%20on%20boxes%2C%20soft%20diffused%20natural%20window%20light%2C%20warm%20neutral%20background%2C%20minimalist%20Japanese%20tidy%20aesthetic%2C%20professional%20estate%20organization%20service%2C%20slightly%20desaturated%20gentle%20tones%2C%20editorial%20documentary%20style&width=800&height=600&seq=reason-02-v3&orientation=squarish",
  },
  {
    num: "03",
    icon: "ri-building-2-line",
    title: "不動産・法人対応",
    text: "不動産会社様の残置物撤去・退去後クリーニング、法人様の産廃回収・オフィス移転まで、継続案件・請求書払いにも対応。",
    alt: "不動産・法人案件に対応するオフィスビルと管理書類の様子",
    image:
      "https://readdy.ai/api/search-image?query=Modern%20Japanese%20apartment%20building%20and%20office%20building%20exterior%20with%20clean%20white%20facade%2C%20business%20documents%20and%20property%20management%20files%20neatly%20arranged%20on%20desk%20in%20foreground%2C%20professional%20corporate%20setting%2C%20subtle%20presence%20of%20staff%20in%20background%20discussing%20documents%2C%20bright%20natural%20daylight%2C%20warm%20neutral%20tones%2C%20Japanese%20real%20estate%20corporate%20service%20atmosphere%2C%20slightly%20desaturated%20clean%20aesthetic%2C%20editorial%20commercial%20photography&width=800&height=600&seq=reason-03-v3&orientation=squarish",
  },
  {
    num: "04",
    icon: "ri-price-tag-3-line",
    title: "明朗会計",
    text: "軽トラ積み放題20,000円〜／4トントラック50,000円〜。事前お見積り後の追加請求は一切なし。安心の透明価格です。",
    alt: "追加料金のない明朗会計を示す見積書・契約書と電卓の様子",
    image:
      "https://readdy.ai/api/search-image?query=Japanese%20language%20detailed%20quotation%20document%20and%20contract%20papers%20on%20clean%20light%20wooden%20desk%20surface%2C%20calculator%20with%20clear%20display%20numbers%2C%20professional%20black%20pen%2C%20metal%20clipboard%20with%20documents%20clipped%20neatly%2C%20white%20envelope%2C%20no%20hidden%20fees%20transparent%20pricing%20concept%2C%20bright%20natural%20side%20lighting%2C%20warm%20neutral%20tones%2C%20crisp%20clean%20composition%2C%20Japanese%20corporate%20trustworthy%20accounting%20aesthetic%2C%20slightly%20desaturated%20soft%20colors%2C%20editorial%20product%20photography%20style&width=800&height=600&seq=reason-04-v3&orientation=squarish",
  },
  {
    num: "05",
    icon: "ri-recycle-line",
    title: "適正処分・リサイクル",
    text: "京都府の産廃基準に沿った正しい処分と、再利用可能な品目のリユース買取。まだ使えるモノは査定でお値引きに還元します。",
    alt: "分別された不用品とリサイクルによる適正処分の様子",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20sorted%20recycling%20boxes%20and%20separated%20household%20appliances%20furniture%20materials%20in%20clean%20organized%20facility%2C%20resource%20recovery%20and%20eco-friendly%20waste%20disposal%20concept%2C%20green%20color%20accents%20throughout%20the%20scene%2C%20natural%20light%20streaming%20through%20windows%2C%20fresh%20and%20crisp%20atmosphere%2C%20Japanese%20environmental%20sustainability%20standards%2C%20warm%20neutral%20tones%20with%20subtle%20green%20highlights%2C%20slightly%20desaturated%20clean%20aesthetic%2C%20editorial%20documentary%20photography%2C%20professional%20industrial%20waste%20processing%20service&width=800&height=600&seq=reason-05-v3&orientation=squarish",
  },
  {
    num: "06",
    icon: "ri-shield-user-line",
    title: "女性・高齢者にも安心",
    text: "女性スタッフ在籍・身分証提示・京都府内自社車両。京都 ゴミ屋敷清掃でも、プライバシーを厳守した対応を徹底します。",
    alt: "女性スタッフが高齢のお客様に丁寧にサービス内容を説明する様子",
    image:
      "https://readdy.ai/api/search-image?query=Japanese%20female%20staff%20member%20in%20professional%20clean%20uniform%20gently%20explaining%20service%20details%20to%20elderly%20woman%20in%20bright%20living%20room%2C%20natural%20warm%20smile%20conversation%2C%20clipboard%20and%20documents%20visible%2C%20comfortable%20home%20atmosphere%20with%20soft%20natural%20window%20light%2C%20genuine%20caring%20interaction%20without%20staged%20posing%2C%20warm%20neutral%20tones%2C%20slightly%20desaturated%20soft%20colors%2C%20Japanese%20service%20industry%20trust%20and%20safety%20aesthetic%2C%20editorial%20documentary%20photography%2C%20comfortable%20reassuring%20mood&width=800&height=600&seq=reason-06-v3&orientation=squarish",
  },
];

export default function Reasons() {
  return (
    <section
      id="reasons"
      className="w-full py-20 md:py-28 bg-background-50"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            REASONS TO CHOOSE
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都で<span className="text-primary-500">選ばれ続ける</span>
            <br className="md:hidden" />
            6つの理由
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            京都 不用品回収・京都 遺品整理・京都 ゴミ屋敷清掃を数多くお任せいただく理由は、
            スピード・丁寧さ・法人対応力の三拍子が揃っているから。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <div
              key={r.num}
              className="group relative p-7 rounded-lg overflow-hidden border border-background-200 hover:border-primary-300 transition-colors"
            >
              {/* 背景画像 */}
              <img
                src={r.image}
                alt={r.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
              {/* 黒オーバーレイ - 35%で背景を抑えつつ高級感を演出 */}
              <div className="absolute inset-0 bg-black/35" />
              {/* 下部グラデーション - さらに文字を読みやすく */}
              <div className="absolute inset-x-0 bottom-0 h-3/4 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />

              {/* コンテンツ（最前面） */}
              <div className="relative z-10">
                <div className="flex items-start justify-between mb-5">
                  <div className="w-14 h-14 flex items-center justify-center rounded-md bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
                    <i className={`${r.icon} text-2xl`}></i>
                  </div>
                  <span
                    className="font-mincho text-4xl text-white/40 leading-none"
                    style={{ textShadow: "0 1px 3px rgba(0,0,0,0.2)" }}
                  >
                    {r.num}
                  </span>
                </div>
                <h3
                  className="text-xl md:text-2xl font-bold text-white mb-3"
                  style={{ textShadow: "0 1px 4px rgba(0,0,0,0.3)" }}
                >
                  {r.title}
                </h3>
                <p
                  className="text-white/90 text-sm leading-relaxed"
                  style={{ textShadow: "0 1px 3px rgba(0,0,0,0.25)" }}
                >
                  {r.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}